export const toPath = label => label.toLowerCase().replace(/ /g, '-')
